export const LANGUAGE_MENU_ENABLED = false;
